import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { makeGetPPCForSelectedColorWithId } from '../../../redux/product/selectors/ProductSelector';
import { ProductPlacementCopyBoxAlpha } from '../product-placement-copy-box/productPlacementCopyBoxAlpha';
import { StackBlock } from '@yonderland/andes-react';
export const ProductPlacementCopyAlpha = ({ ppcType }) => {
    const getPPCPositionsForSelectedColor = makeGetPPCForSelectedColorWithId();
    const items = useSelector((state) => getPPCPositionsForSelectedColor(state, ppcType));
    if (!(items === null || items === void 0 ? void 0 : items.length)) {
        return null;
    }
    return (_jsx(StackBlock, { gap: "2", testId: "product-placement-copy", children: items.map((item) => (_jsx(ProductPlacementCopyBoxAlpha, { ppc: item }, item.name))) }));
};
